import { useCallback, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { ArrowLeft } from "lucide-react";
import { apiFetch } from "@/lib/reels";
import { CategoryGroups, CategoryVideos, useCategories } from "@/components/reels/CreatorLibrary";

export const CombinedLibrary = ({ onBack, quality }) => {
  const { getToken } = useAuth();
  const cats = useCategories();
  const [data, setData] = useState(null);
  const [active, setActive] = useState(null);
  const [version, setVersion] = useState(0);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    const res = await apiFetch("/library", { token: await getToken() });
    setData(await res.json());
    setVersion((v) => v + 1);
  }, [getToken]);

  useEffect(() => {
    load().catch((e) => { setError(e.message); setData({ counts: {}, total: 0, creators: 0 }); });
  }, [load]);

  if (!data || !cats) return <div className="flex justify-center py-6"><span className="rs-spinner" /></div>;
  return (
    <div className="flex flex-col gap-4 rs-fade" data-testid="combined-library">
      <div className="rs-material flex items-center gap-2 p-4">
        <button className="rs-bordered !px-2.5" onClick={onBack} aria-label="Back" data-testid="combined-back-btn"><ArrowLeft size={16} /></button>
        <div className="min-w-0 flex-1">
          <p className="text-[18px] font-extrabold">All Recipes</p>
          <p className="rs-secondary text-[12px]" data-testid="combined-summary">{data.total} videos from {data.creators} chef{data.creators === 1 ? "" : "s"}</p>
          {error && <p className="text-[12px] text-[#c62d22]" data-testid="combined-error">{error}</p>}
        </div>
      </div>
      <CategoryGroups cats={cats} counts={data.counts} active={active} onPick={setActive} />
      {active && (
        <div className="rs-material flex flex-col gap-3 p-4" data-testid="category-panel">
          <CategoryVideos path="/library/videos" category={active} version={version} quality={quality} cats={cats} onMoved={() => load()} showCreator />
        </div>
      )}
    </div>
  );
};
